export const daFatturare = (riga) =>
  Number(riga.DaFatturare ?? riga.EraPresente) === 1;

export function calcolaPrefatturazione(costiCorsi) {
  const result = costiCorsi.map((tipo) => {
    const corsi = tipo.corsi.map((corso) => {
      const n =
        Number(corso.EsclusoPrefattura) === 1
          ? 0
          : corso.Presenti.filter(daFatturare).length;
      const totaleCorso =
        Number(corso.CostoAdHoc) === 1
          ? n > 0
            ? Number(corso.OreTotaliCorso || 0) *
              Number(corso.ImportoOrario || 0)
            : 0
          : Number(corso.ModalitaFatturazione) === 1
            ? n * Number(corso.Tariffa || 0)
            : n > 0
              ? Number(corso.OreTotaliCorso || 0) *
                Number(corso.CostoForfait || 0)
              : 0;
      return { ...corso, totaleCorso, MostraInStampa: n > 0 ? 1 : 0 };
    });
    return {
      ...tipo,
      corsi,
      totaleTipoCorso: corsi.reduce((sum, c) => sum + c.totaleCorso, 0),
    };
  });
  result.Totale = result.reduce((sum, t) => sum + t.totaleTipoCorso, 0);
  return result;
}

export function righePrefatturazione(corsi) {
  return corsi.flatMap((tipo) =>
    tipo.corsi
      .filter((corso) => corso.MostraInStampa === 1)
      .flatMap((corso) =>
        corso.Presenti.filter(daFatturare).map((p) => ({
          Corso: corso.IDCorso,
          Lavoratore: p.Lavoratore,
        })),
      ),
  );
}

export const gruppoStampabile = (tipo) =>
  tipo.corsi.some((corso) => corso.MostraInStampa === 1);
